import React from 'react';
import {
  List,
  Datagrid,
  ChipField,
  DateField,
  ReferenceField,
  ReferenceManyField,
  SingleFieldList,
  TextField,
  TextInput,
  SelectInput,
  ShowButton,

  Filter,
} from 'react-admin';
import FullNameField from '../General/FullNameField';


const AccountFilter = props => (
  <Filter {...props}>
    <SelectInput
      label="Is Approved"
      source="approvedAt"
      choices={[
        // Backend supports custom filter values _null_ and _not_null_
        // that will compare if db field is NULL or NOT NULL
        { id: '_not_null_', name: 'Yes' },
        { id: '_null_', name: 'No' },
      ]}
    />
    <TextInput
      alwaysOn
      label="Account Number"
      source="_LIKE_accountNumber"
    />
  </Filter>
);


export default props => (
  <List
    {...props}
    title="Accounts"
    bulkActionButtons={false}
    filters={<AccountFilter />}
    sort={{ field: 'createdAt', order: 'DESC' }}
  >
    <Datagrid>
      <TextField source="accountNumber" />
      <ReferenceField label="Account owner" source="userId" reference="users" linkType="show" sortable={false}>
        <FullNameField />
      </ReferenceField>
      <ReferenceManyField label="Restrictions" reference="accountRestrictions" target="accountNumber" sortable={false}>
        <SingleFieldList linkType={false}>
          <ChipField source="type.title" />
        </SingleFieldList>
      </ReferenceManyField>
      <DateField source="createdAt" />
      <DateField source="approvedAt" />
      <ShowButton />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/components/Account/List.js